// storage/Storage.js
//------------------------- Token -------------------------//
export const setToken = async (token) => {
  try {
    if (!token) {
      // Clearing token -> also clear audio mode
      localStorage.removeItem("access_token");
      localStorage.removeItem("isAudioModeOn");
    } else {
      // Saving token (login) -> default audio mode OFF for new session
      localStorage.setItem("access_token", token);
      // Set default off explicitly so fresh logins start with audio off
      localStorage.setItem("isAudioModeOn", JSON.stringify(false));
    }
  } catch (error) {
    console.log("Error setting token", error);
  }
};

export const getToken = async () => {
  try {
    const token = localStorage.getItem("access_token");
    if (!token) return null;

    // Decode JWT to extract expiry time
    const payload = JSON.parse(atob(token.split(".")[1]));
    const isExpired = payload.exp * 1000 < Date.now(); // Convert to milliseconds and compare
    if (isExpired) {
      // Token expired -> clear token and audio mode
      localStorage.removeItem("access_token");
      localStorage.removeItem("isAudioModeOn");
      console.log("Token expired. Clearing localStorage (token + audio mode).");
      return null;
    }

    return token;
  } catch (error) {
    console.log("Error getting or validating token", error);
    // defensively clear broken token/audio state
    try {
      localStorage.removeItem("access_token");
      localStorage.removeItem("isAudioModeOn");
    } catch (e) {}
    return null;
  }
};
